// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"137e4315","531":"39445e3f","859":"633d8923"}[chunkId] + ".chunk.js";
};